import Section from '../components/Section/Section';
import styles from './Ticket.module.css';
import TicketView from './TicketView';


const TicketTopPane = (props) => {
    const {
        ticket,
        jobNumber,
        utility,
        closeTicketWindow,
        handleDeleteTicket,
        refreshTicketList,
    } = props;

  
    
    return (

<Section id="pageHeader" bgColor="#f6f6f6">
<div className="col py-5">
    <div className="row no-gutters flex-column flex-sm-row align-items-start">
        {/* Job Number */}
        <div className={`col mb-4 mb-md-0 ${styles.pageHeaderItem} jobNumber`}>
            <div className="d-flex flex-column">
              <label className="label">Job</label>
              <div className={styles.jobInfoDisplay}>
                {jobNumber}
              </div>
              <a className="btn-link danger" href="#" onClick={handleDeleteTicket}>Delete Ticket</a>
            </div>
          </div>

        {/* Utility */}
        <div className={`col-md-3 mb-4 mb-md-0 ${styles.pageHeaderItem} jobUtility`}>
            <div className="d-flex flex-column">
              <label className="label">Utility</label>
              <div className={styles.jobInfoDisplay}>
                {utility}
              </div>
            </div>
        </div>

       

    </div>
</div>
</Section>
)};

export default TicketTopPane